import { useState } from 'react';

import Grid from '@zenbusiness/zui/Grid';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { formatStringWithOnlyDot } from '#client/utils/text';

const eyeShow = (
  <SharedAsset
    alt=""
    height={24}
    src="/icon/micro/eye-simple-show.svg"
    width={24}
  />
);
const eyeHide = (
  <SharedAsset
    alt=""
    height={24}
    src="/icon/micro/eye-simple-hide.svg"
    width={24}
  />
);
export default function AccountNumber({ accountNumber, loading, fullAccountNumber }) {
  const [show, setShow] = useState(false);
  const hiddenValue = accountNumber ? formatStringWithOnlyDot(accountNumber) : '';
  const handleClick = () => {
    setShow((isShow) => !isShow);
  };

  if (!loading && !accountNumber) {
    return null;
  }

  return (
    <Grid
      item
      md={4}
      xs={12}
    >
      <Stack
        direction="column"
        gap="8px"
      >
        <Text
          color="tertiary"
          size="xs"
          uppercase
        >
          Account
        </Text>
        {loading ? (
          <Skeleton width="150px" />
        ) : (
          <Stack
            alignItems="center"
            direction="row"
          >
            <Text size="lg">{show ? fullAccountNumber : hiddenValue}</Text>
            {fullAccountNumber && (
              <Stack
                alignItems="center"
                aria-label="eyes-switch"
                onClick={handleClick}
              >
                {show ? eyeHide : eyeShow}
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
    </Grid>
  );
}

AccountNumber.propTypes = {
  accountNumber: PropTypes.string,
  loading: PropTypes.bool,
  fullAccountNumber: PropTypes.string
};
